import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';


@Injectable({
  providedIn: 'root',
})
export class IntegrationService {

  constructor(
    private readonly http: HttpClient,
  ) {
  }

  private channelUrl = environment.baseURL + '/channel/';
  private integrationsUrl = environment.baseURL + '/integrations/';
  private olxIntegrationUrl = environment.baseURL + '/olx/integration/';
  private tgIntegrationUrl = environment.baseURL + '/tg/integration';
  private tgConnectUrl = environment.baseURL + '/tg/connect';

  public getChannels() {
    return this.http.get<any>(this.channelUrl)
      .pipe(map(res => res.data));
  }

  public getChannel(channel_id: string) {
    return this.http.get<any>(this.channelUrl + channel_id)
      .pipe(map(res => res.data));
  }

  public createChannel(payload: any) {
    return this.http.post<any>(this.channelUrl, payload)
      .pipe(map(res => res.data));
  }

  public getIntegrations() {
    return this.http.get<any>(this.integrationsUrl)
      .pipe(map(res => res.data));
  }

  public getOlxIntegration(channel_id: string) {
    return this.http.get<any>(this.olxIntegrationUrl + channel_id)
      .pipe(map(res => res.data));
  }

  public updateChannel(channel_id: string, payload: {
    name?: string,
    responsible_ids?: string[],
    is_first_reply?: boolean,
    first_reply?: string
  }) {
    return this.http.put<any>(this.channelUrl + channel_id, payload)
      .pipe(map(res => res.data));
  }

  public disconnectOlx(channel_id: string) {
    return this.http.post<any>(this.olxIntegrationUrl + 'disconnect', { channel_id })
      .pipe(map(res => res.data));
  }

  public disconnect(channel_id: string) {
    return this.http.post<any>(environment.baseURL + '/integrations/disconnect', { channel_id });
  }

  public getFacebookLoginUrl(channel_id: string, user_id: string, company_id: string) {
    return this.http.get<any>(environment.baseURL + '/facebook/login', { params: { channel_id, user_id, company_id } })
      .pipe(map(res => res.data));
  }

  public selectFacebookPage(channel_id: string, page_id: string) {
    return this.http
      .post<any>(environment.baseURL + '/facebook/page', { channel_id, page_id })
      .pipe(map(res => res.data));
  }

  public refresh(channel_id: string) {
    return this.http.post<any>(this.olxIntegrationUrl + 'refresh', { channel_id })
      .pipe(map(res => res.data));
  }

  public archiveChannel(channel_id: string) {
    return this.http.post<any>(this.channelUrl + `archive/${channel_id}`, {})
      .pipe(map(res => res.data));
  }

  public unarchiveChannel(channel_id: string) {
    return this.http.post<any>(this.channelUrl + `unarchive/${channel_id}`, {})
      .pipe(map(res => res.data));
  }

  public createViber(channel_id: string, number: string, isHandleFiles: boolean): Observable<any> {
    const url = `${environment.baseURL}/viber`;
    const formattedNumber = number.replace('+', '');
    return this.http.post<any>(url, { channel_id: channel_id, number: formattedNumber, is_handle_files: isHandleFiles })
      .pipe(map(res => res.data));
  }

  public restartViber(channel_id: string): Observable<any> {
    const url = `${environment.baseURL}/viber/restart`;
    return this.http.post<any>(url, { channel_id })
      .pipe(map(res => res.data));
  }

  public createWhatsApp(channel_id: string, number: string): Observable<any> {
    const url = `${environment.baseURL}/whatsapp`;
    const formattedNumber = number.replace('+', '');
    return this.http.post<any>(url, { channel_id, number: formattedNumber })
      .pipe(map(res => res.data));
  }

  public createProm(channel_id: string, token: string): Observable<any> {
    const url = `${environment.baseURL}/prom`;
    return this.http.post<any>(url, { channel_id: channel_id, token: token })
      .pipe(map(res => res.data));
  }

  public deleteTiktok(channel_id: string): Observable<any> {
    const url = `${environment.baseURL}/tiktok/auth`;
    return this.http.delete<any>(url, { params: { channel_id } })
      .pipe(map(res => res.data));
  }

  public getTiktokLoginUrl(channel_id: string, redirect_url: string): Observable<any> {
    const url = `${environment.baseURL}/tiktok/login`;
    return this.http.get<any>(url, { params: { channel_id, redirect_url } })
      .pipe(map(res => res.data));
  }

  public getTiktokLink(channel_id: string, redirect_url: string): Observable<any> {
    const url = `${environment.baseURL}/v2/tiktok/link`;
    return this.http.get<any>(url, { params: { channel_id, redirect_url } })
      .pipe(map(res => res.data));
  }
}
